import React, { useState, useMemo } from 'react';

import { isWebComponentEnvironment } from '@/helpers';
import { SELECT_COLORS_LIST } from '@/constants';
import { Popover } from '@/components';
import ColorPicker from '@/components/Popover/ColorPicker';
import ColorSelectModal from '@/components/Modals/ColorSelectModal';

import IconChecked from '@/icons/icon-checked.svg';
import IconCheckedWhite from '@/icons/icon-checked-white.svg';

import {
  ColorSelectWrapper,
  AddColorButton,
  ColorItem,
  AddIconStyled,
  Icon
} from './styles';

const webComponent = isWebComponentEnvironment();

const ColorSelectionPanel = (props) => {
  const {
    selected,
    colorsList = null,
    additionalColors,
    onChange,
    onAddNewColor = null,
    colorItemClassName = ''
  } = props;

  const [isModalOpen, setModalOpen] = useState(false);
  const renderColors = useMemo(() =>
    (colorsList || getRenderColors(additionalColors || [], SELECT_COLORS_LIST.length)),
    [colorsList, additionalColors]
  );
  const [anchorEl, setAnchorEl] = useState(null);

  const shouldBeWhite = (hex) => {
    var colorInt = hex.replace('#','').replace('transparent', 'ffffff');
    colorInt = isNaN(colorInt)? 'ffffff' : colorInt;
    var bigint = parseInt((colorInt), 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;
    return r < 128 || g < 128 || b < 128;
  };

  const handleAddNewColorClick = (event) => {
    if (webComponent) {
      setAnchorEl(event.currentTarget);
    } else {
      setModalOpen(true);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ColorSelectWrapper colorsList={colorsList}>
        {renderColors.map(item => (
          <ColorItem
            className={colorItemClassName? colorItemClassName : ''}
            key={`font-color-${item}`}
            color={item}
            selected={selected === item}
            onClick={onChange.bind(null, item)}
          >
            {selected === item && (
              <Icon src={shouldBeWhite(item) ? IconCheckedWhite : IconChecked} />
            )}
          </ColorItem>
        ))}
        {onAddNewColor && (
          <>
            <AddColorButton className={colorItemClassName ? colorItemClassName : ''} onClick={handleAddNewColorClick}>
              <AddIconStyled />
            </AddColorButton>
            <Popover open={!!anchorEl} anchorEl={anchorEl} onClose={handlePopoverClose} anchorOrigin={{ vertical: 'top', horizontal: 'left' }}>
              <ColorPicker color={selected} onChange={onChange} onClose={handlePopoverClose} />
            </Popover>
          </>
        )}
      </ColorSelectWrapper>

      <ColorSelectModal open={isModalOpen} setOpen={setModalOpen} onChange={onAddNewColor} />
    </>
  );
};

export default React.memo(ColorSelectionPanel);

const getRenderColors = (colors, size) => {
  let res = SELECT_COLORS_LIST.concat(colors);
  if (res.length > size) {
    res.splice(0, res.length - size)
  }
  return res;
};
